module.exports = __webpack_public_path__ + "img/open_frame.c9dd7a53.png";